import React, { useState } from 'react';
import { ExportButton } from '@common/components';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import Filters from 'works/legacy/lib/filters';
import { WorkerFilterInput } from '@common/graphql';

type WorkersExportType = {
  createWorkersExport: {
    success: boolean;
  };
};

const GENERATE_CSV_EXPORT = gql`
  mutation createWorkersExport($input: CreateWorkersExportInput!) {
    createWorkersExport(input: $input) {
      success
    }
  }
`;

type Props = {
  loading?: boolean;
  disabled?: boolean;
  filters?: WorkerFilterInput;
};

export function ExportOnDemandButton({
  loading = false,
  disabled = false,
  filters,
}: Props) {
  const [timeoutActive, setTimeoutActive] = useState(false);
  const LOCALSTORAGE_FILTER_KEY = 'OnDemandWorkerTable';

  const onCompleted = ({
    createWorkersExport: { success },
  }: WorkersExportType) => {
    if (success) {
      createMessage(
        'success',
        "Your CSV Export is being generated. You'll receive an email with the final file when complete. Large exports may take a few minutes.",
        10
      );
      setTimeoutActive(true);
      setTimeout(() => setTimeoutActive(false), 5000);
    } else {
      createMessage('error', 'CSV Export failed. Please try again.');
    }
  };

  const [performExport, { loading: mutationLoading }] = useMutation(
    GENERATE_CSV_EXPORT,
    {
      onCompleted: onCompleted,
      onError: () => {
        createMessage('error', 'CSV Export failed. Please try again.');
      },
    }
  );

  const onClick = () => {
    performExport({
      variables: {
        input: {
          filters: filters || Filters.getFilters(LOCALSTORAGE_FILTER_KEY),
        },
      },
    });
  };

  return (
    <ExportButton
      disabled={disabled || timeoutActive}
      loading={loading || mutationLoading}
      onClick={onClick}
    >
      Export
    </ExportButton>
  );
}
